// periodStayMin / periodStayMax are whole months. 0 is a real value, not "unset":
// periodStayMin 0 means "no minimum stay" (the backend skips the min-stay check and the
// search's `periodStayMin <= requestedMonths` filter matches every stay), and
// periodStayMax 0 means "no maximum". Never test these with plain truthiness.

const isUnset = (value) => value === undefined || value === null || value === '';

// A month count the landlord typed (input `valueAsNumber`): a non-negative integer.
// NaN (empty input) and null (never typed) are not valid; 0 is.
export const isValidStayPeriod = (value) => Number.isInteger(value) && value >= 0;

// Whether the room actually imposes a minimum stay worth displaying.
export const hasMinStay = (room) => Number(room?.periodStayMin) > 0;

// A new minimum stay that exceeds the room's maximum. periodStayMax 0 is "no maximum", so
// it never caps anything.
export const isMinStayAboveMax = (min, max) => Number(max) > 0 && min > Number(max);

// Initial value of the min-stay input in the listing editor. A room that never had a
// minimum stay set starts at 1 (the historical default); a stored 0 must stay 0, otherwise
// the next save writes the 1 back without the landlord touching the field.
export const getPeriodStayMinInitialValue = (room) => {
    const value = room?.periodStayMin;
    if (isUnset(value) || isNaN(Number(value))) return 1;
    return Number(value);
};
